import { GetterTree } from 'vuex'
import { ModuleState } from './types'
import { RootState } from '@/types'

export const getters: GetterTree<ModuleState, RootState> = {
  pending: (state) => (townId: number) => { return state.pending[townId] },
}
